import React from "react";
import SiviElSabunu from "../Components/product/SiviElSabunu";
import PageHeader from "../Components/common/PageHeader";
import ProductSEO from "../Components/common/ProductSEO";
import { t } from "i18next";

function SiviElSabunuPage() {
    return (
        <>
            <ProductSEO
                name="Sıvı El Sabunu"
                description="Cildi kurutmadan nazikçe temizleyen, hoş kokulu sıvı el sabunu."
                slug="sivielsabunu"
                imagePath="assets/images/20-kg/15.webp"
            />
            <PageHeader title={t("SIVI EL SABUNU")} />
            <SiviElSabunu />
        </>
    );
}

export default SiviElSabunuPage;